import { GitstreamLogo } from '@linearb/linui-common';
import { StyledHeaderContainer } from './WelcomeHeader.style';

const WelcomeHeader = () => (
  <StyledHeaderContainer>
    <h1>Welcome to</h1>
    <GitstreamLogo />
  </StyledHeaderContainer>
);

export default WelcomeHeader;
